module.exports = __webpack_public_path__ + "static/media/Kris.a4d12e82.jpeg";